import type { ReactNode } from 'react';
import type { ThemeRegistry } from '@classy/theme-sdk';
import { useAuth } from './AuthContext.js';
import { LoginScreen } from './LoginScreen.js';

export interface AuthGateProps {
  /** Theme registry used to render the pre-auth landing page. */
  themeRegistry: ThemeRegistry;
  children: ReactNode;
}

/**
 * Pre-auth: shows the themed sign-in landing.
 * Authenticated: renders children.
 * Loading: shows the same landing with a "Signing in…" pill so the
 * background stays continuous through the redirect round-trip.
 *
 * Tenant-allowlist 403s surface as "Your school hasn't been approved yet"
 * via the API client error handling, not here — this gate is just sign-in.
 */
export function AuthGate({ themeRegistry, children }: AuthGateProps) {
  const auth = useAuth();

  if (auth.status === 'unauthenticated' || auth.status === 'loading') {
    return <LoginScreen registry={themeRegistry} />;
  }

  return <>{children}</>;
}
